import { createAsyncThunk } from '@reduxjs/toolkit';
import cartMasterService from '../../services/cart/cartMasterService';
import { CartInStore } from '../cart/types';
import {
  mapResponseToAvailableShippingMethod,
  parseShippingMethodsToPayload,
} from './shippingMethods.utils';
import { GetShippingMethodsResponse, SetShippingMethodsEntry } from './types';
import { setCart } from '../cart';

const waiveAkHiShipping = window?.purTogglesEnabled('waive_ak_hi_shipping');

export const getAvailableShippingMethods = createAsyncThunk(
  'shippingMethods/getAvailableShippingMethods',
  async (
    {
      locale,
      overwritePaidInHomeSetupShipping,
      customInHomeSetupPricing,
    }: {
      locale: string;
      overwritePaidInHomeSetupShipping: boolean;
      customInHomeSetupPricing: number | null | false | undefined;
    },
    { getState, rejectWithValue },
  ) => {
    const { cart } = getState() as { cart: CartInStore };
    let shippingMethods;
    try {
      shippingMethods = (await cartMasterService.callToMethod({
        cartId: cart.id,
        isDraft: cart.isDraft,
        methodName: cartMasterService.methodsMap.getShippingMethods,
        paramsObject: {
          overwritePaidInHomeSetupShipping,
          customInHomeSetupPricing,
          waiveAkHiShipping,
        },
      })) as GetShippingMethodsResponse;
    } catch (error) {
      const typedError = error as { apiErrors?: { code: string }[] };
      return rejectWithValue({
        errorCode: typedError.apiErrors?.[0]?.code,
      });
    }

    const availableShippingMethods = shippingMethods.map((shippingMethod) =>
      mapResponseToAvailableShippingMethod(
        shippingMethod,
        cart.lineItems,
        locale,
      ),
    );

    const payload = {
      availableShippingMethods,
    };

    return payload;
  },
);

export const setShippingMethodsForAllProductsInCart = createAsyncThunk(
  'shippingMethods/setShippingMethodsForAllProductsInCart',
  async (
    {
      shippingMethods,
      overwritePaidInHomeSetupShipping,
      customInHomeSetupPricing,
    }: {
      shippingMethods: SetShippingMethodsEntry[];
      overwritePaidInHomeSetupShipping: boolean;
      customInHomeSetupPricing: number | null | false | undefined;
    },
    { getState, dispatch, rejectWithValue },
  ) => {
    const { cart } = getState() as { cart: CartInStore };
    const { id, isDraft, store } = cart;
    const storeKey = store?.key || null;


    const newCart = (await cartMasterService.callToMethod({
      cartId: id,
      isDraft,
      methodName: cartMasterService.methodsMap.setShippingMethods,
      paramsObject: {
        selectedShippingMethods: parseShippingMethodsToPayload(shippingMethods, isDraft, storeKey),
        overwritePaidInHomeSetupShipping,
        customInHomeSetupPricing,
        waiveAkHiShipping,
        cartId: id,
      },
    })) as CartInStore;

    dispatch({
      type: 'setShippingMethodStatus',
      status: 'loading',
    });

    try {
      dispatch({
        type: 'shippingMethods/setShippingMethods',
        payload: shippingMethods,
      });
      dispatch({
        type: 'setShippingMethodStatus',
        status: 'success',
      });
      return dispatch(setCart(newCart));
    } catch (error) {
      dispatch({
        type: 'setShippingMethodStatus',
        status: 'failed',
      });
      return rejectWithValue({
        // TODO: fix error handling
        errorCode: error,
      });
    }
  },
);
